import {FC, useState} from "react";
import {urlApiHttp} from "../../../helper/api";
import {ITypeRadar} from "../../../types";
import {IDirectionDataSideBar} from "../../../pages/Dashboard/Dashboard.type";
import CardItem from "../../CardItem";
import {SidebarTab} from "../../Sidebar";
import {dataMapDirectionFilters} from "../dataMapFilters";
import {BlockFIlteredMap} from "../SidebarCardUI/BlockFIlteredMap";
import {BlockDescription} from "../SidebarCardUI/BlockDescription";
import {TitleCard} from "../styles";
import {FEATURE_CLUSTER_BATTERY_METRIC_ENABLED} from "../../../config/featureFlags";

interface IProps {
  dataDirection: IDirectionDataSideBar | undefined;
  typeRadar: ITypeRadar;
  handleCardClick: (id: number | string, name: string) => void;
  sortOption: any;
  handleSortTitle: any;
  handleSort: any;
  colorTitle?: string;
}

export const SideBarContentMapDirection: FC<IProps> = ({
  dataDirection,
  typeRadar,
  handleCardClick,
  sortOption,
  handleSortTitle,
  handleSort,
  colorTitle,
}) => {
  const [isShowTitleParams, setIsShowTitleParams] = useState(true);

  return (
    <>
      <TitleCard color={colorTitle}>{dataDirection?.name}</TitleCard>
      <BlockDescription
        text={dataDirection?.desc}
        image={
          dataDirection?.image?.url &&
          `${urlApiHttp}/cms/techradar/${dataDirection?.image?.url}`
        }
        type="map"
      />
      <BlockFIlteredMap
        handleSortTitle={handleSortTitle}
        handleSort={handleSort}
        sortOption={sortOption}
        dataMapFiltered={dataMapDirectionFilters}
        setIsShowTitleParams={setIsShowTitleParams}
        isShowTitleParams={isShowTitleParams}
      />
      {dataDirection?.clusters.map((item) => {
        return (
          <CardItem
            key={item.id}
            invest_volume_tier={item.invest_volume_tier}
            market_volume_tier={item.market_volume_tier}
            title={item.name}
            isFlashFilterEnabled={item.growth_potential}
            isCritical={item.critical}
            isNational={item.national}
            isGpb={item.gpb}
            type={SidebarTab.Clusters}
            onClick={() => handleCardClick(item.documentId || "", item.name)}
            imageCard={item.image?.url}
            imageCardAlt={item.image?.alternativeText || ""}
            isShowTitleParams={isShowTitleParams}
            typeRadar={typeRadar}
            batteryRussia={item.battery_russia || ""}
            batteryWorld={item.battery_world || ""}
            showBattery={FEATURE_CLUSTER_BATTERY_METRIC_ENABLED}
          />
        );
      })}
    </>
  );
};
